import { useEffect, useState, useRef } from "react";
import api from "../lib/api";

// Polls the unresolved-failed-notifications counter every 2 minutes.
// Feeds the sidebar badge on Contabilidad. Zero noise when count=0.

export default function useFiscalUnresolved(restaurantId, intervalMs = 120_000) {
  const [count, setCount] = useState(0);
  const [byType, setByType] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!restaurantId) {
      setCount(0); setByType(null);
      return;
    }
    let alive = true;
    const load = async () => {
      try {
        const r = await api.getFiscalNotificationsUnresolved(restaurantId);
        if (!alive) return;
        setCount(r?.count || 0);
        setByType(r?.by_type || null);
      } catch {
        // Silent: badge is a nice-to-have, don't spam the UI with errors.
      }
    };
    load();
    timerRef.current = setInterval(load, intervalMs);
    return () => {
      alive = false;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [restaurantId, intervalMs]);

  return { count, byType };
}
